<header></header>
<div class="post-login-2">
    <div class="post-login-2-col-1 h-100">
        <left-panel activeTab="2"></left-panel>
    </div>
    <div class="post-login-2-col-2" *ngIf="this.cardDetail?.length > 0">
        <div class="p-10">

            <div class="font-600 font-size-20px line-h-40   color-base-1700">
                {{"MyCards" | translate }}
            </div>

            <!------------------------------- by  for 9th feb 24 release  ---------------------------------------------->
            <grid-row class="justify-content-between align-item-center">
                <!-- <grid-col col="auto">
                    <grid-row class="align-item-center col-space-min">
                        <grid-col col="auto">
                            <div class="form-group">
                                <div class="custom-toggle-2">
                                                <input type="checkbox" id="toggle1" class="not-on-this" [disabled]="this.enableViewCard"
                                                    [(ngModel)]="ViewCardDetail" (click)="EnableViewCard($event.target)">
                                                <label for="toggle1" class="not-on-this"></label>
                                            </div>
                            <div class="custom-toggle-2">
                                    <input type="checkbox" id="toggle1">
                                    <label for="toggle1" class="not-on-this"></label>
                                </div> 
                            </div>
                        </grid-col>
                        <grid-col col="auto">
                            <div class="font-500 font-size-12px line-h-14 color-base-1200">
                                {{"HideMyNumber" | translate }}
                            </div>
                        </grid-col>
                    </grid-row>
                </grid-col> -->
                <grid-col col="auto" *ngIf="this.loyalityPoints != undefined &&  this.loyalityPoints != ''">
                    <div class="loyalty-box-small" (click)="RewardsLoyaltyPoints()">
                        <grid-row class="col-space align-item-center">
                            <grid-col col="auto">
                                <!-- <ng-icon iconClass="icon-gift-box mr-10" width="24" height="24"></ng-icon> -->
                                <ng-icon iconClass="icon-redeem-small " width="24" height="24"></ng-icon>
                                <!-- <strong class="font-size-16px color-base-100 font-600">{{this.loyalityPoints}} Pts</strong> -->
                                <span class="font-size-16px ml-10 color-base-100 font-600">
                                    {{this.loyalityPoints}} Pts</span>
                                <!-- <span class="font-size-12px color-base-100 ">Pts</span> -->
                            </grid-col>
                        </grid-row>
                    </div>
                </grid-col>
            </grid-row>
            <!------------------------------- by  for 9th feb 24 release  ---------------------------------------------->

        </div>

        <div class="card-slider mt-10 p-10">
            <owl-carousel-o [options]="carouselOptions" (translated)="selectCard($event)">
                <ng-template carouselSlide *ngFor="let item of this.cardDetail; let i = index">
                    <div class="card" [ngClass]="getClass(i,item)">
                        <span class="active-text-box" *ngIf="item.activationFlag == 'N'" (click)="activateCard()">
                            {{"ActivateCard" | translate}}
                        </span>
                        <div class="img-box">
                            <!-- <img src="../../assets/images/MC UNIPAL.png" alt=""> -->
                            <img [src]="'assets/images/'+imagePath(item?.productCode)+'.png'" alt="">
                            <!-- <div class="text-box"
                                    [ngClass]="item?.cardCategory == 'MC UNIPAL' ? 'color-black': 'color-white'"> -->
                            <div class="text-box"
                                [ngClass]="item?.productCode == '050' ? 'color-white' : item?.productCode == '042' ?  'color-base-3600' : item?.productCode == '001' ? ' color-base-3800' :'color-white'">

                                <grid-row class="align-item-center justify-content-between">
                                    <grid-col col="auto">
                                        <ng-icon iconClass="icon-unipalBird mr-10" width="22" height="22"
                                            *ngIf="item?.productCode == '050'"></ng-icon>
                                        <ng-icon iconClass="icon-imtiaz-logo-new" width="100" height="30"
                                            *ngIf="item?.productCode == '016'"></ng-icon>
                                        <ng-icon iconClass="icon-imtiaz-logo-new" width="100" height="30"
                                            *ngIf="item?.productCode == '028'"></ng-icon>
                                        <ng-icon iconClass="icon-imtiaz-world-elite background-size-100" width="60"
                                            height="27" *ngIf="item?.productCode == '001'"></ng-icon>
                                        <!-- && item?.productCode != '004' -->
                                        <ng-icon iconClass="icon-creditcard-logo" width="60" height="27"
                                            *ngIf="item?.productCode != '016' && item?.productCode != '028' && item?.productCode != '001'"></ng-icon>
                                        <!-- && item?.productCode != '050' -->

                                        <!-- <ng-icon iconClass="icon-unipalBird" width="22" height="22"
                                                *ngIf="item?.cardCategory == 'MC UNIPAL'"></ng-icon> -->
                                    </grid-col>
                                    <grid-col col="auto">
                                        <div class="title" [ngClass]="item?.productCode == '007' ? 'prepaid-100': ''">
                                            <!-- <img *ngIf="item?.productCode == '040'" src="~/../assets/images/cw-logo.png" alt=""> -->
                                            <!-- <img *ngIf="item?.productCode == '009'" src="~/../assets/images/cep-logo.png" alt=""> -->
                                            <!-- <img *ngIf="item?.productCode == '016'" src="~/../assets/images/Platinum.png" alt=""> -->
                                            <!-- <img *ngIf="item?.productCode == '017'" src="~/../assets/images/Platinum.png" alt=""> -->
                                            <!-- <img *ngIf="item?.productCode == '028'" src="~/../assets/images/world.png" alt=""> -->
                                            <img *ngIf="item?.productCode == '040'" src="~/../assets/images/world.png"
                                                alt="">
                                            <!-- <img *ngIf="item?.productCode == '029'" src="~/../assets/images/world.png" alt=""> -->
                                            <!-- <img *ngIf="item?.productCode == '005'" src="~/../assets/images/platinum-title.png" alt="">  -->
                                            <!-- <img *ngIf="item?.productCode == '004'" src="~/../assets/images/titanium-logo.png" alt=""> -->
                                            <!-- <img *ngIf="item?.productCode == '013'" src="~/../assets/images/world.png" alt=""> -->
                                            <!-- <img *ngIf="item?.productCode == '001'" src="~/../assets/images/we-logo.png" alt=""> -->
                                            <!-- <img *ngIf="item?.productCode == '007'" src="~/../assets/images/PlatinumPrepaid.png" alt=""> -->
                                        </div>
                                    </grid-col>

                                    <grid-col col="auto">
                                        <grid-row class="align-item-center col-space-min" *ngIf="item?.nickName">
                                            <grid-col col="auto">
                                                <div class="bg-base-100 br-40 pl-8 pr-8 pt-4 pb-4 pt-2">
                                                    <div class="font-400 font-size-10px color-base-1500">
                                                        {{item?.nickName}}
                                                    </div>
                                                </div>
                                            </grid-col>
                                            <grid-col col="auto">
                                                <ng-icon iconClass="icon-contactless" width="20" height="26"
                                                    *ngIf="item?.productCode != '001'"></ng-icon>
                                                <ng-icon iconClass="icon-contacless-world-elite background-size-100"
                                                    width="20" height="26" *ngIf="item?.productCode == '001'"></ng-icon>
                                            </grid-col>
                                        </grid-row>
                                    </grid-col>
                                </grid-row>


                                <grid-row class="justify-content-between mt-10">
                                    <grid-col col="auto">
                                        <div class="font-600 font-size-14px line-h-20">
                                            <!-- 5270 170 8088 4924 -->
                                            <!-- {{item?.maskedCardNumber}} -->
                                            <!-- <ng-container *ngIf="!showCardDetails">
                                                    {{item?.maskedCardNumber}}
                                                </ng-container>
                                                <ng-container *ngIf="showCardDetails && isLoadingComplete">
                                                    {{this.NumberView}}
                                                </ng-container> -->
                                            <ng-container>
                                                {{ this.NumberView && isLoadingComplete ? this.NumberView :
                                                item?.maskedCardNumber }}
                                            </ng-container>

                                        </div>
                                    </grid-col>
                                    <!-- <grid-col col="auto">
                                            <div class="eye-button" (click)="hideShowCard()">
                                                <div class="eye-button-item" *ngIf="!showCardDetails">
                                                    <span>{{"Show" | translate }}</span>
                                                    <img src="assets/theme/component-icons/eye-open.svg"
                                                        alt="Show">
                                                </div>
                                                <div class="eye-button-item" *ngIf="showCardDetails">
                                                    <span>{{"Hide" | translate }}</span>
                                                    <img src="assets/theme/component-icons/eye-close.svg"
                                                        alt="Hide">
                                                </div>
                                            </div>

                                        </grid-col> -->
                                    <!-- [ngClass]="item?.productCode == '004' ? 'border-000': ''" -->
                                    <grid-col col="auto" *ngIf="!disabledServices">
                                        <div class="eye-button" (click)="hideShowCard()">
                                            <div class="eye-button-item" *ngIf="!showCardDetails">
                                                <span>{{"Show" | translate }}</span>
                                                <img src="assets/theme/component-icons/eye-open.svg" alt="Show">
                                            </div>
                                            <div class="eye-button-item" *ngIf="showCardDetails">
                                                <span>{{"Hide" | translate }}</span>
                                                <img src="assets/theme/component-icons/eye-close.svg" alt="Hide">
                                            </div>
                                        </div>
                                    </grid-col>
                                </grid-row>


                                <grid-row class="mt-10">
                                    <!-- <grid-col col="6" > unipal and prepaid only shown
                                            <div class="font-400 font-size-10px line-h-14" >
                                                {{"OutstandingBalance" | translate }}
                                            </div>
                                            <div class="font-600 font-size-16px line-h-25" [ngClass]="item?.productCode == '001' ? 'color-base-100': ''">
                                                <span>
                                                    {{item?.cardCurrencyISO}}
                                                </span>
                                                <span>
                                                    {{item?.outstandingAmount}}
                                                </span>
                                            </div>
                                        </grid-col> -->
                                    <grid-col col="6">
                                        <ng-container *ngIf="item?.productCode != '007' && item?.productCode != '050'">
                                            <div class="font-400 font-size-10px line-h-14">
                                                {{"OutstandingBalance" | translate }}
                                            </div>
                                            <div class="font-600 font-size-16px line-h-25"
                                                [ngClass]="item?.productCode == '001' ? 'color-base-100': ''">
                                                <span>
                                                    {{item?.cardCurrencyISO}}
                                                </span>
                                                <span>
                                                    {{item?.outstandingAmount}}
                                                </span>
                                            </div>
                                        </ng-container>
                                    </grid-col>


                                    <grid-col col="6" class="text-align-right">
                                        <!-- mt-16 -->
                                        <div class="font-400 font-size-10px line-h-14">
                                            {{"AvailableBalance" | translate }}
                                        </div>
                                        <div class="font-600 font-size-16px line-h-25"
                                            [ngClass]="item?.productCode == '001' ? 'color-base-100': ''">
                                            <strong>
                                                {{item?.cardCurrencyISO}}
                                            </strong>
                                            <strong>
                                                {{item?.availableCreditLimit}}
                                            </strong>
                                        </div>
                                    </grid-col>
                                </grid-row>

                                <grid-row class="justify-content-between align-item-center mt-7">
                                    <grid-col col="9">
                                        <div *ngIf="item?.productCode != '007' && item?.productCode != '050'">
                                            <custom-progress-bar [barCounter]="false" [currentValue]="usedPercentage"
                                                [smallBar]="true" width="w-100">
                                            </custom-progress-bar>
                                        </div>
                                    </grid-col>
                                    <grid-col col="auto">
                                        <ng-icon iconClass="icon-MasterCard" width="40" height="25"
                                            *ngIf="item?.productCode != '001'"></ng-icon>
                                        <ng-icon iconClass="icon-mc-world-elite background-size-100" width="45"
                                            height="35" *ngIf="item?.productCode == '001'"></ng-icon>
                                    </grid-col>
                                </grid-row>
                                <grid-row class="justify-content-between align-item-center mt-7">
                                    <grid-col col="auto">
                                        <div>
                                            <!-- [ngClass]="item?.productCode == '050' ? 'color-base-100': 'color-base-400'" -->
                                            <span class="font-400 font-size-10px line-h-14  mr-4">
                                                {{"Expiry"| translate}}
                                            </span>
                                            <!-- <span class="font-600 font-size-10px line-h-14 mr-16"
                                                    *ngIf="item?.expiryDate"
                                                    [ngClass]="item?.cardCategory == 'MC UNIPAL' ? 'color-base-100': ''">
                                                    {{item?.expiryDate|date:"MM YY"}} 
                                                    {{ this.commonP.StringToDate(item?.expiryDate) | date: "MM/YY" }}
                                                </span> -->
                                            <span class="font-600 font-size-10px line-h-14 mr-16"
                                                [ngClass]="item?.productCode == '050' ? 'color-base-100': ''">
                                                <ng-container *ngIf="!showCardDetails">***</ng-container>
                                                <ng-container
                                                    *ngIf="showCardDetails && isLoadingComplete">{{this.epDate}}</ng-container>
                                            </span>
                                            <!-- [ngClass]="item?.productCode == '050' ? 'color-base-100': 'color-base-400'" -->
                                            <span class="font-400 font-size-10px line-h-14  mr-4">
                                                {{"CVV" | translate}}
                                            </span>
                                            <span class="font-600 font-size-10px line-h-14"
                                                [ngClass]="item?.productCode == '050' ? 'color-base-100': ''">
                                                <ng-container *ngIf="!showCardDetails">***</ng-container>
                                                <ng-container
                                                    *ngIf="showCardDetails && isLoadingComplete">{{this.cNumber}}</ng-container>
                                            </span>
                                        </div>
                                    </grid-col>
                                    <grid-col col="auto">
                                        <!-- [ngClass]="item?.productCode == '050' ? 'color-base-100': 'color-base-400'" -->
                                        <div class="font-400 font-size-10px line-h-14">
                                            <!-- {{"PhysicalCard" | translate}} -->
                                            {{item?.physicalOrVirtual}}
                                        </div>
                                    </grid-col>
                                </grid-row>

                            </div>
                        </div>

                    </div>
                </ng-template>
            </owl-carousel-o>
        </div>

        <div class="p-10">

            <!-- <div class="card mt-10" *ngFor="let item of this.cardDetail; let i = index"
                [ngClass]="this.selectedCardIndex == i ? 'active': getClass(i,item)" (click)="selectCard(i)">
                <div class="img-box">
                    <img src="~/../assets/images/card-platinum.png" alt="">
                    <div class="text-box">
                        <grid-row class="align-item-center justify-content-between">
                            <grid-col col="auto">
                                <ng-icon iconClass="icon-creditcard-logo" width="60" height="27"></ng-icon>
                            </grid-col>
                            <grid-col col="auto">
                                <grid-row class="align-item-center col-space-min" *ngIf="item?.nickName">
                                    <grid-col col="auto">
                                        <div class="bg-base-100 br-40 pl-8 pr-8 pt-4 pb-4 pt-2">
                                            <div class="font-400 font-size-10px color-base-1500">
                                                {{item?.nickName}}
                                            </div>
                                        </div>
                                    </grid-col>
                                    <grid-col col="auto">
                                        <ng-icon iconClass="icon-contactless" width="20" height="26"></ng-icon>
                                    </grid-col>
                                </grid-row>
                            </grid-col>
                        </grid-row>
                        <div class="font-500 font-size-14px line-h-20 mt-10">
                            
                            {{item?.maskedCardNumber}}
                        </div>
                        <div class="font-400 font-size-10px line-h-14 color-base-400 mt-16">
                            {{"AvailableBalance" | translate }}
                        </div>
                        <div class="font-600 font-size-16px line-h-25">
                            <span>
                                {{item?.cardCurrencyISO}}
                            </span>
                            <span>
                                {{item?.availableCreditLimit}}
                            </span>
                        </div>
                        <grid-row class="justify-content-between align-item-center mt-7">
                            <grid-col col="9">
                                <custom-progress-bar [barCounter]="false" currentValue="60" smallBar="true"
                                    width="w-100">
                                </custom-progress-bar>
                            </grid-col>
                            <grid-col col="auto">
                                <ng-icon iconClass="icon-MasterCard" width="40" height="25"></ng-icon>
                            </grid-col>
                        </grid-row>
                        <grid-row class="justify-content-between align-item-center mt-7">
                            <grid-col col="auto">
                                <div>
                                    <span class="font-400 font-size-10px line-h-14 color-base-400 mr-4">
                                        {{"Expiry"| translate}}
                                    </span>
                                    <span class="font-600 font-size-10px line-h-14 mr-16" *ngIf="item?.expiryDate">
                                        
                                        {{ this.commonP.StringToDate(item?.expiryDate) | date: "M/d" }}

                                    </span>
                                    <span class="font-400 font-size-10px line-h-14 color-base-400 mr-4">
                                        {{"CVV" | translate}}
                                    </span>
                                    <span class="font-600 font-size-10px line-h-14">
                                        ***
                                    </span>
                                </div>
                            </grid-col>
                            <grid-col col="auto">
                                <div class="font-400 font-size-10px line-h-14 color-base-400">
                                    {{"PhysicalCard" | translate}}
                                </div>
                            </grid-col>
                        </grid-row>
                    </div>
                </div>
            </div> -->

            <div class="font-400 font-size-14px line-h-20 color-base-1200 mt-50">
                {{"CardDetails" | translate }}
            </div>

            <div class="box-shadow bg-base-100 border border-color-900 text-align-center br-16 mt-16 p-16">
                <grid-row class="justify-content-between mt-8">
                    <!-- <p>{{this.selectedCardDetail?.maskedCardNumber}}</p> -->
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800">
                            {{"CardHolderName" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500">
                            {{this.selectedCardDetail?.cardHolderName}}
                        </div>
                    </grid-col>
                </grid-row>
                <grid-row class="justify-content-between mt-24">
                    <!-- <p>{{this.selectedCardDetail?.maskedCardNumber}}</p> -->
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800">
                            {{"YourCreditLimit" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500">
                            {{this.selectedCardDetail?.totalCreditLimit |amountFormatter}}
                        </div>
                    </grid-col>
                </grid-row>
                <grid-row class="justify-content-between mt-24">
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800">
                            {{"TotalAvialableLimit" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500">
                            {{this.selectedCardDetail?.totalAvailableCreditLimit |amountFormatter}}
                        </div>
                    </grid-col>
                </grid-row>
                <grid-row class="justify-content-between mt-24">
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800">
                            {{"OutstandingBalance" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500">
                            {{this.selectedCardDetail?.lastStatementRemAmount |amountFormatter}}
                        </div>
                    </grid-col>
                </grid-row>
                <!-- <grid-row class="justify-content-between mt-24">
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800">
                            {{"OutstandingBalance" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500">
                            {{this.selectedCardDetail?.outstandingAmount |amountFormatter}}
                        </div>
                    </grid-col>
                </grid-row> -->
                <grid-row class="justify-content-between mt-24 align-item-center">
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800">
                            {{"MinimumAmountdue" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500 text-align-right">
                            {{this.selectedCardDetail?.minimumAmountDue |amountFormatter}}
                        </div>
                        <div class="font-400 font-size-12px line-h-14 color-base-1800 text-align-right"
                            *ngIf="this.selectedCardDetail?.nextDueDate">
                            {{this.commonP.StringToDate(this.selectedCardDetail?.nextDueDate)|date: "dd/MM" }}
                        </div>
                    </grid-col>
                </grid-row>
                <grid-row class="justify-content-between mt-24 align-item-center">
                    <grid-col col="auto">
                        <div class="font-400 font-size-12px line-h-20 color-base-1800">
                            {{"StatementAmount" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500 text-align-right">
                            {{this.selectedCardDetail?.lastStatementAmount |amountFormatter}}
                        </div>
                        <div class="font-400 font-size-12px line-h-14 color-base-1800 text-align-right"
                            *ngIf="this.selectedCardDetail?.lastStatementDate">
                            {{this.commonP.StringToDate(this.selectedCardDetail?.lastStatementDate)| date: "dd/MM/YY"}}
                        </div>
                    </grid-col>
                </grid-row>
                <grid-row class="justify-content-between mt-24">
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800">
                            {{"RemaningStatementAmount" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500">
                            {{this.selectedCardDetail?.lastStatementRemAmount |amountFormatter}}
                        </div>
                    </grid-col>
                </grid-row>
                <grid-row class="justify-content-between mt-24 align-item-center mb-8">
                    <grid-col col="auto">
                        <div class="font-400 font-size-12px line-h-20 color-base-1800 text-align-right">
                            {{"LastPayment" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500 text-align-right">
                            {{this.selectedCardDetail?.lastPaymentAmount |amountFormatter}}
                        </div>
                        <div class="font-400 font-size-12px line-h-14 color-base-1800 text-align-right"
                            *ngIf="this.selectedCardDetail?.lastPaymentDate">
                            {{this.commonP.StringToDate(this.selectedCardDetail?.lastPaymentDate)|date: "dd/MM/YY"}}
                        </div>
                    </grid-col>
                </grid-row>
            </div>

        </div>
    </div>
    <div class="post-login-2-col-3" *ngIf="this.cardDetail?.length  > 0">
        <div *ngIf="this.cardDetail?.length > 0 && ! this.ViewGroupTransaction">
            <div class="font-600 font-size-20px line-h-40 color-base-1700 mt-8">
                {{this.selectedCardDetail?.cardCategory | translate }}
            </div>
            <div class="mt-30" *ngIf="this.disabledServices">
                <grid-row class="align-item-center col-space-min">
                    <grid-col col="auto">
                        <ng-icon iconClass="icon-info-gray-big" width="40" height="40"></ng-icon>
                    </grid-col>
                    <grid-col col="auto" mobile="9" class="mt-mobile-10">
                        <div class="font-400 font-size-14px color-base-500 line-h-20">
                            {{ "YourCardStopped" | translate }}
                        </div>
                    </grid-col>
                </grid-row>
            </div>
            <div class="font-400 font-size-14px line-h-20 color-base-1200 mt-30">
                {{"CardActions" | translate }}
            </div>
            <grid-row class="col-space-min no-wrap overflow-x-auto mt-16">
                <grid-col col="auto">
                    <div class="card-box-big item-size-94" [routerLink]="['/PayCard']"
                        [queryParams]="{ id: this.selectedCardDetail?.internalId,type:'C',flow:'', max:this.selectedCardDetail?.maxPaymentAmount }"
                        *ngIf="(!this.disabledServices) &&  (this.selectedCardDetail?.activationFlag != 'N')">
                        <div>
                            <!-- <ng-icon iconClass="icon-card-transfer" width="30" height="24"></ng-icon> -->
                            <ng-icon iconClass="icon-pay-card-green" width="24" height="24"></ng-icon>
                        </div>
                        <!-- <div class="font-600 font-size-10px line-h-14 p-6 mt-10">
                            {{"TopUp" | translate}}
                        </div> -->
                        <div class="font-600 font-size-10px line-h-14 p-6 mt-10"
                            *ngIf="this.selectedCardDetail?.productCode === '050' || this.selectedCardDetail?.productCode === '007'">
                            {{"TopUpCard" | translate}}
                        </div>
                        <div class="font-600 font-size-10px line-h-14 p-6 mt-10"
                            *ngIf="this.selectedCardDetail?.productCode !== '050' && this.selectedCardDetail?.productCode !== '007'">
                            {{ "PayNow" | translate }}
                        </div>
                    </div>
                    <div class="card-box-big item-size-94 disabled" [routerLink]="['/PayCard']"
                        [queryParams]="{ id: this.selectedCardDetail?.internalId,type:'C',flow:'' }"
                        *ngIf="this.disabledServices || this.selectedCardDetail?.activationFlag == 'N'">
                        <div>
                            <!-- [queryParams]="{ id: this.selectedCardDetail?.internalId,type:'C',flow:'Pay' }" -->
                            <ng-icon iconClass="icon-pay-card-green" width="30" height="24"></ng-icon>
                        </div>
                        <div class="font-600 font-size-10px line-h-14 p-6 mt-10"
                            *ngIf="this.selectedCardDetail?.productCode === '050' || this.selectedCardDetail?.productCode === '007'">
                            {{"TopUpCard" | translate}}
                        </div>
                        <div class="font-600 font-size-10px line-h-14 p-6 mt-10"
                            *ngIf="this.selectedCardDetail?.productCode !== '050' && this.selectedCardDetail?.productCode !== '007'">
                            {{ "PayNow" | translate }}
                        </div>
                    </div>
                </grid-col>
                <grid-col col="auto"
                    *ngIf="(this.selectedCardDetail?.freezed =='N' && !this.disabledServices ) && (this.selectedCardDetail?.activationFlag != 'N')">
                    <div class="card-box-big item-size-94" (click)="this.showModal(1)">
                        <!-- <ng-icon iconClass="icon-card-freeze" width="26" height="27"></ng-icon> -->
                        <ng-icon iconClass="icon-freez-card-green" width="27" height="24"></ng-icon>
                        <div class="font-600 font-size-10px line-h-14 mt-6 color-base-1500 mt-12">
                            {{ "FreezCard" | translate }}
                        </div>
                    </div>
                </grid-col>
                <grid-col col="auto"
                    *ngIf="(this.selectedCardDetail?.freezed =='N' && this.disabledServices) || ( this.selectedCardDetail?.activationFlag == 'N')">
                    <div class="card-box-big disabled item-size-94" (click)="this.showModal(1)">
                        <ng-icon iconClass="icon-freez-card-green" width="26" height="27"></ng-icon>
                        <div class="font-600 font-size-10px line-h-14 mt-6 color-base-1500 mt-12">
                            {{ "FreezCard" | translate }}
                        </div>
                    </div>
                </grid-col>
                <grid-col col="auto"
                    *ngIf="(this.selectedCardDetail?.freezed=='Y' && !this.disabledServices) || !this.selectedCardDetail?.activationFlag == 'N'">
                    <div class="card-box-big item-size-94" (click)="this.showModal(2)">
                        <ng-icon iconClass="icon-card-freeze" width="26" height="27"></ng-icon>
                        <div class="font-600 font-size-10px line-h-14 mt-6 color-base-1500 mt-12">
                            {{ "UnFreezCard" | translate }}
                        </div>
                    </div>
                </grid-col>
                <grid-col col="auto"
                    *ngIf="(this.selectedCardDetail?.freezed=='Y' && this.disabledServices ) || (this.selectedCardDetail?.activationFlag == 'N')">
                    <div class="card-box-big disabled item-size-94" (click)="this.showModal(2)">
                        <ng-icon iconClass="icon-card-freeze" width="26" height="27"></ng-icon>
                        <div class="font-600 font-size-10px line-h-14 mt-6 color-base-1500 mt-12">
                            {{ "UnFreezCard" | translate }}
                        </div>
                    </div>
                </grid-col>
                <!-- <grid-col col="auto" *ngIf="!this.disabledServices && this.selectedCardDetail?.activationFlag != 'N'">
                    this.showModal(17)   existing user
                    <div class="card-box-big item-size-94" (click)="sinadUserpin()">
                        <ng-icon iconClass="icon-card-pin" width="26" height="26"></ng-icon>
                        <ng-icon iconClass="icon-manage-pin-green" width="26" height="26"></ng-icon>
                        <div class="font-600 font-size-10px line-h-14 mt-6 color-base-1500 mt-7 p-5">
                            {{ "ManageCardPIN" | translate }}
                        </div>
                        <div class="manage-pin-box-drop-menu top-145">
                                <a class="manage-pin-box-drop-menu-item" (click)="this.showModal(3)">
                                    <ng-icon iconClass="icon-mobile-blue" width="24" height="24"></ng-icon>
                                    <span>{{ "ReissueCardPIN" | translate }}</span>
                                </a>
                            </div>
                    </div>
                </grid-col> -->
                <grid-col col="auto" *ngIf="(this.disabledServices || this.selectedCardDetail?.activationFlag == 'N')">
                    <div class="card-box-big disabled item-size-94">
                        <ng-icon iconClass="icon-card-pin" width="26" height="26"></ng-icon>
                        <div class="font-600 font-size-10px line-h-14 mt-6 color-base-1500 mt-7 p-5">
                            {{ "ManagePIN" | translate }}
                        </div>

                    </div>
                </grid-col>
                <grid-col col="auto">
                    <div class="card-box-big item-size-94" [routerLink]="['/CardNickName']"
                        [queryParams]="{ id: this.selectedCardDetail?.internalId,nickName:this.selectedCardDetail?.nickName }"
                        *ngIf=" !this.disabledServices && this.selectedCardDetail?.activationFlag != 'N'">
                        <!-- <ng-icon iconClass="icon-card-nick-name" width="26" height="26"></ng-icon> -->
                        <ng-icon iconClass="icon-nickname-green" width="26" height="26"></ng-icon>
                        <div class="font-600 font-size-10px line-h-14 mt-6 color-base-1500 mt-12"
                            *ngIf="this.selectedCardDetail?.nickName != ''">
                            {{ "EditNickname" | translate }}
                        </div>
                        <div class="font-600 font-size-10px line-h-14 mt-6 color-base-1500 mt-12"
                            *ngIf="this.selectedCardDetail?.nickName == ''">
                            {{ "AddNickname" | translate }}
                        </div>
                    </div>
                    <div class="card-box-big item-size-94 disabled" [routerLink]="['/CardNickName']"
                        [queryParams]="{ id: this.selectedCardDetail?.internalId,nickName:this.selectedCardDetail?.nickName }"
                        *ngIf="this.disabledServices || this.selectedCardDetail?.activationFlag == 'N' ">
                        <!-- <ng-icon iconClass="icon-card-nick-name" width="26" height="26"></ng-icon> -->
                        <ng-icon iconClass="icon-nickname-green" width="26" height="26"></ng-icon>
                        <div class="font-600 font-size-10px line-h-14 mt-6 color-base-1500 mt-12"
                            *ngIf="this.selectedCardDetail?.nickName != ''">
                            {{ "EditNickname" | translate }}
                        </div>
                        <div class="font-600 font-size-10px line-h-14 mt-6 color-base-1500 mt-12"
                            *ngIf="this.selectedCardDetail?.nickName == ''">
                            {{ "AddNickname" | translate }}
                        </div>
                    </div>

                </grid-col>
                <grid-col col="auto"
                    *ngIf="this.UnGroupCardTransactionHistory && this.UnGroupCardTransactionHistory.length > 0 || this.UnGroupCardTransactionHistory && this.UnGroupCardTransactionHistory.length == 0">
                    <div class="card-box-big item-size-94" [routerLink]="['/MonthSelect']"
                        [queryParams]="{ id: this.selectedCardDetail?.internalId,type:'C' }"
                        *ngIf="this.UnGroupCardTransactionHistory && this.UnGroupCardTransactionHistory.length > 0 && this.selectedCardDetail?.activationFlag != 'N'">
                        <!-- <ng-icon iconClass="icon-card-statement" width="26" height="32"></ng-icon> -->
                        <ng-icon iconClass="icon-card-statement-green" width="26" height="32"></ng-icon>
                        <div class="font-600 font-size-10px line-h-14 mt-6 color-base-1500 mt-6">
                            {{ "CardStatement" | translate }}
                        </div>
                    </div>
                    <div class="card-box-big disabled item-size-94"
                        *ngIf="(this.UnGroupCardTransactionHistory && this.UnGroupCardTransactionHistory.length==0) || (this.selectedCardDetail?.activationFlag == 'N')">
                        <!-- <ng-icon iconClass="icon-card-statement" width="26" height="32"></ng-icon> -->
                        <ng-icon iconClass="icon-card-statement-green" width="26" height="32"></ng-icon>
                        <div class="font-600 font-size-10px line-h-14 mt-6 color-base-1500 mt-6">
                            {{ "CardStatement" | translate }}
                        </div>
                    </div>
                </grid-col>
                <grid-col col="auto">
                    <div class="card-box-big item-size-94 disabled" [routerLink]="['/StopCard']"
                        [queryParams]="{ id: this.selectedCardDetail?.internalId }"
                        *ngIf="this.disabledServices || this.selectedCardDetail?.activationFlag == 'N'">
                        <!-- <ng-icon iconClass="icon-card-stop" width="26" height="26"></ng-icon> -->
                        <ng-icon iconClass="icon-stop-card-green" width="26" height="26"></ng-icon>
                        <div class="font-600 font-size-10px line-h-14 p-3 color-base-1500 mt-10">
                            {{ "StopCard" | translate }}
                        </div>
                    </div>
                    <div class="card-box-big item-size-94" [routerLink]="['/StopCard']"
                        [queryParams]="{ id: this.selectedCardDetail?.internalId }"
                        *ngIf="(!this.disabledServices  )&& (this.selectedCardDetail?.activationFlag != 'N' )">
                        <!-- <ng-icon iconClass="icon-card-stop" width="26" height="26"></ng-icon> -->
                        <ng-icon iconClass="icon-stop-card-green" width="26" height="26"></ng-icon>
                        <div class="font-600 font-size-10px line-h-14 p-3 color-base-1500 mt-10">
                            {{ "StopCard" | translate }}
                        </div>
                    </div>
                </grid-col>
                <!-- <grid-col col="auto">
                        <div class="card-box-big item-size-94" (click)="showModal(15)">
                            <ng-icon iconClass="icon-email-blue-sm" width="26" height="26"></ng-icon>
                            <div class="font-600 font-size-10px line-h-14 p-3 color-base-1500 mt-10">
                                {{ "RequestLetter" | translate }}
                            </div>
                        </div>
                    </grid-col> -->
                <grid-col col="auto">
                    <div class="card-box-big item-size-94" (click)="PendingRequest()"
                        *ngIf=" !this.disabledServices && this.selectedCardDetail?.activationFlag != 'N' ">
                        <!-- (click)="showModal(10)" -->
                        <!-- <ng-icon iconClass="icon-more-action" width="26" height="26"></ng-icon> -->
                        <ng-icon iconClass="icon-more-action-green" width="26" height="26"></ng-icon>
                        <div class="font-600 font-size-10px line-h-14 p-3 color-base-1500 mt-10">
                            {{ "MoreActions" | translate }}
                        </div>
                    </div>
                    <div class="card-box-big item-size-94 disabled" (click)="PendingRequest()"
                        *ngIf="( this.disabledServices || this.selectedCardDetail?.activationFlag == 'N')">
                        <!-- (click)="showModal(10)" -->
                        <!-- <ng-icon iconClass="icon-more-action" width="26" height="26"></ng-icon> -->
                        <ng-icon iconClass="icon-more-action-green" width="26" height="26"></ng-icon>
                        <div class="font-600 font-size-10px line-h-14 p-3 color-base-1500 mt-10">
                            {{ "MoreActions" | translate }}
                        </div>
                    </div>
                </grid-col>
            </grid-row>


        </div>

        <div>
            <!-- short Transactions -->
            <div *ngIf="!this.ViewGroupTransaction">
                <grid-row class="justify-content-between mt-30"
                    *ngIf="this.transactionsLoading || (this.UnGroupCardTransactionHistory && this.UnGroupCardTransactionHistory.length > 0)">
                    <grid-col col="auto">
                        <div class="font-400 font-size-14px line-h-20 color-base-1200 letter-spacing-1">
                            {{"Transactionhistory" | translate }}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-500 font-size-12px line-h-18 color-primary text-align-center letter-spacing-1 link"
                            (click)="onTrasactionsChange('LAST 10 TRANSACTIONS')">
                            {{"ViewMore" | translate}}
                        </div>
                    </grid-col>
                </grid-row>
                <!-- Inline skeleton while this card's transactions load. Mirrors the
                     row layout below so the list does not jump when data lands. -->
                <div class="bg-base-100 box-shadow border border-color-900 br-16 mt-10 p-16"
                    *ngIf="this.transactionsLoading">
                    <grid-row class="justify-content-between mb-20 mt-5"
                        *ngFor="let row of this.skeletonRows">
                        <grid-col col="auto">
                            <div class="skeleton-loading mb-10" style="width: 170px; height: 14px;"></div>
                            <div class="skeleton-loading" style="width: 90px; height: 12px;"></div>
                        </grid-col>
                        <grid-col col="auto">
                            <div class="skeleton-loading" style="width: 80px; height: 14px;"></div>
                        </grid-col>
                    </grid-row>
                </div>
                <div class="bg-base-100 box-shadow border border-color-900 br-16 mt-10 p-16"
                    *ngIf="!this.transactionsLoading && this.UnGroupCardTransactionHistory && this.UnGroupCardTransactionHistory.length > 0">
                    <grid-row class="justify-content-between mb-20 mt-5"
                        *ngFor="let item of this.UnGroupCardTransactionHistory">
                        <grid-col col="auto">
                            <div class="font-400 font-size-12px color-base-1500 mb-10"
                                *ngIf="this.selectedCardDetail?.primaryOrSupplementary=='Y'">
                                <span class="bg-primary-shade-100 br-20 color-base-100 pl-8 pr-8 pt-4 pb-4">
                                    {{this.selectedCardDetail?.maskedCardNumber}}
                                </span>
                            </div>
                            <div class="mb-10">
                                <span
                                    class="bg-warning br-40 pl-8 pr-8 pt-4 pb-4 font-400 font-size-12px color-base-100 mr-5"
                                    *ngIf="item?.transactionStatus=='H'">
                                    {{"Hold" | translate}}
                                </span>
                                <!-- <span class="bg-primary-shade-100 br-40 pl-8 pr-8 pt-4 pb-4 font-400 font-size-12px color-base-100">
                                    {{"SuppCard4940" | translate}}
                                </span> -->
                            </div>
                            <div class="font-400 font-size-12px line-h-20 color-base-1500">
                                {{item?.transactionDescription}}
                            </div>
                            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-5"
                                *ngIf="item?.transactionDate">
                                {{this.commonP.TwelveHourFormate(item?.transactionDate)|date:'h:mm a'}}
                            </div>
                        </grid-col>
                        <grid-col col="auto">
                            <div class="font-600 font-size-14px line-h-20 color-black text-align-right"
                                *ngIf="item?.debitCreditIndicator=='D'">
                                - {{"BHD" | translate }} {{item?.billingAmount|amountFormatter}}
                            </div>
                            <div class="font-600 font-size-14px line-h-20 color-success text-align-right"
                                *ngIf="item?.debitCreditIndicator=='C'">
                                {{"BHD" | translate }} {{item?.billingAmount |amountFormatter}}
                            </div>
                            <div class="font-400 font-size-12px line-h-12 color-base-1800"
                                *ngIf="item?.transactionCurrency!=='BHD'">
                                {{item?.transactionCurrency}} {{item?.transactionAmount}}
                            </div>
                            <!-- <div class="font-400 font-size-12px line-h-12 color-base-1800" *ngIf="this.selectedCardDetail?.primaryOrSupplementary=='Y'">
                                {{item?.transactionCardNumber}}
                            </div> -->
                        </grid-col>
                    </grid-row>

                </div>
                <div *ngIf="!this.transactionsLoading && this.UnGroupCardTransactionHistory?.length==0">
                    <grid-row class="justify-content-center align-item-center h-100 pt-50">
                        <grid-col col="4" mobile="12">
                            <div class="text-align-center mt-50 mt-mobile-0">
                                <ng-icon iconClass="icon-no-transaction" width="120" height="120"></ng-icon>
                            </div>
                            <div class="font-400 font-size-14px line-h-20 color-base-500 text-align-center mt-10">
                                {{"Youhaventmadeany" | translate }}
                            </div>
                        </grid-col>
                    </grid-row>
                </div>
            </div>


            <!-- full history -->
            <grid-row class="justify-content-between align-item-center" *ngIf="this.ViewGroupTransaction">
                <grid-col col="auto" mobile="12">
                    <grid-row class="col-space-min align-item-center">
                        <grid-col col="auto">
                            <!-- <div class="link">
                                <ng-icon iconClass="icon-back-button bg-transprent" width="22" height="22" (click)="back()"></ng-icon>
                            </div> -->
                            <div class="link" (click)="back()">
                                <ng-icon iconClass="icon-arrow-left-black" width="22" height="22"></ng-icon>
                            </div>
                        </grid-col>
                        <grid-col col="auto">
                            <div class="font-400 font-size-14px line-h-20 color-base-1200 letter-spacing-1">
                                {{"Transactionhistory" | translate }}
                            </div>
                        </grid-col>
                    </grid-row>
                </grid-col>
                <grid-col col="3" mobile="12" class="mt-mobile-10">
                    <div class="form-group">
                        <drop-down-list borderRadius="br-100" dropDownImage="false" dropDownSearch="false"
                            [selectedValue]="this.selectedTrasactions" [dropDownData]="this.Trasactionslist"
                            (itemselected)="onTrasactionsChange($event)">
                            {{this.selectedTrasactions}}
                        </drop-down-list>
                    </div>
                </grid-col>
            </grid-row>
            <!-- <div *ngIf="!this.ViewGroupTransaction">
                <div class="bg-base-100 box-shadow border border-color-900 br-16 mt-16 p-16 link"
                    *ngFor="let item of this.UnGroupCardTransactionHistory" (click)="this.showModal(7)">
                    <grid-row class="justify-content-between align-item-center mt-8">
                        <grid-col col="auto">
                            <div class="font-400 font-size-12px color-base-1500">
                                <span
                                    class="bg-primary-shade-100 br-20 color-base-100 pl-8 pr-8 pt-4 pb-4">{{this.selectedCardDetail?.maskedCardNumber}}</span>
                            </div>
                            <div class=" font-400 font-size-12px line-h-20 color-base-1500 mt-10">
                                {{item?.transactionDescription}}
                            </div>
                            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7"
                                *ngIf="item?.transactionDate">
                                {{item?.transactionDate}}
                            </div>
                        </grid-col>
                        <grid-col col="auto">
                            <div class="font-600 font-size-14px line-h-20 color-error text-align-right"
                                *ngIf="item?.debitCreditIndicator=='D'">
                                - {{"BHD" | translate }} {{item?.billingAmount}}
                            </div>
                            <div class="font-600 font-size-14px line-h-20 color-success text-align-right"
                                *ngIf="item?.debitCreditIndicator=='C'">
                                {{"BHD" | translate }} {{item?.billingAmount}}
                            </div>
                            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-right"
                                *ngIf="item?.transactionCurrency!=='BHD'">
                                {{item?.transactionCurrency}} {{item?.transactionAmount}}
                            </div>
                        </grid-col>
                    </grid-row>
                </div>
            </div> -->
            <!-- <div *ngFor="let item of this.GroupCardTransaction">
                 {{item?.label}}
             </div> -->
            <div *ngIf="this.ViewGroupTransaction">
                <div class="mt-20" *ngIf="this.transactionsLoading">
                    <div class="bg-base-100 box-shadow border border-color-900 br-16 mt-5 p-15">
                        <grid-row class="justify-content-between align-item-center mb-20 mt-5"
                            *ngFor="let row of this.skeletonRows">
                            <grid-col col="auto">
                                <div class="skeleton-loading mb-10" style="width: 170px; height: 14px;"></div>
                                <div class="skeleton-loading" style="width: 90px; height: 12px;"></div>
                            </grid-col>
                            <grid-col col="auto">
                                <div class="skeleton-loading" style="width: 80px; height: 14px;"></div>
                            </grid-col>
                        </grid-row>
                    </div>
                </div>
                <div class="mt-20" *ngFor="let items of this.GroupCardTransactionHistory let i=index"
                    [hidden]="this.transactionsLoading">
                    <span class="font-400 font-size-14px color-base-1500">{{items?.label}}</span>
                    <div class="bg-base-100 box-shadow border border-color-900 br-16 mt-5 p-15">
                        <grid-row class="justify-content-between align-item-center link"
                            *ngFor="let item of items.cardTransactions" (click)="this.showModal(71,item)">

                            <grid-col col="auto">

                                <!-- <div class="font-400 font-size-12px color-base-1500">
                                                    <span
                                                        class="bg-primary-shade-100 br-20 color-base-100 pt-5 pb-2 pl-10 pr-10">{{this.selectedCardDetail?.maskedCardNumber}}</span>
                                                </div> -->
                                <span
                                    class="bg-warning br-40 pl-8 pr-8 pt-4 pb-4 font-400 font-size-12px color-base-100 mr-5"
                                    *ngIf="item?.transactionStatus=='H'">
                                    {{"Hold" | translate}}
                                </span>
                                <div class="font-400 font-size-12px line-h-20 color-base-1500">
                                    <!-- {{"YourCreditLimit" | translate}} -->
                                    {{item?.transactionDescription}}
                                </div>
                                <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7"
                                    *ngIf="item?.transactionDate">
                                    <!-- Today - 8:32PM -->
                                    <!-- {{item?.transactionDate}} -->
                                    {{this.commonP.TwelveHourFormate(item?.transactionDate)|date:'dd/MM/yyyy h:mm a'}}
                                </div>

                            </grid-col>
                            <grid-col col="auto">
                                <div class="font-600 font-size-14px line-h-20 color-black text-align-right"
                                    *ngIf="item?.debitCreditIndicator=='D'">
                                    - {{"BHD" | translate }} {{item?.billingAmount|amountFormatter}}
                                </div>
                                <div class="font-600 font-size-14px line-h-20 color-success text-align-right"
                                    *ngIf="item?.debitCreditIndicator=='C'">
                                    {{"BHD" | translate }} {{item?.billingAmount|amountFormatter}}
                                </div>
                                <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-right"
                                    *ngIf="item?.transactionCurrency!=='BHD'">
                                    {{item?.transactionCurrency}} {{item?.transactionAmount}}
                                </div>
                            </grid-col>
                        </grid-row>
                    </div>

                    <!-- <grid-row class="justify-content-between mt-20">
                <grid-col col="auto">
                    <div class=" font-400 font-size-12px line-h-20 color-base-1500 text-align-left">
                        {{"PayCard" | translate}}
                    </div>
                    <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-left">
                        19/5 - 11:08AM
                    </div>
                </grid-col>
                <grid-col col="auto">
                    <div class="font-600 font-size-14px line-h-20 color-success text-align-right">
                        - {{"BHD" | translate }} 64.205
                    </div>
                </grid-col>
            </grid-row>
            <grid-row class="justify-content-between align-item-center mt-20 mb-8">
                <grid-col col="auto">
                    <div class=" font-400 font-size-12px line-h-20 color-base-1500 text-align-left">
                        {{"FoodWorldWLL" | translate}}
                    </div>
                    <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-left">
                        16/5 - 10:28AM
                    </div>
                </grid-col>
                <grid-col col="auto">
                    <div class="font-600 font-size-14px line-h-20 color-error text-align-right">
                        - {{"BHD" | translate }} 100.000
                    </div>
                    <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-right">
                        5270 17•• •••• 4924
                    </div>
                </grid-col>
            </grid-row> -->

                </div>
                <div *ngIf="!this.transactionsLoading && this.GroupCardTransactionHistory?.length==0" class="mt-50">
                    <grid-row class="justify-content-center align-item-center h-100 pt-50">
                        <grid-col col="4" mobile="12">
                            <div class="text-align-center mt-50 mt-mobile-0">
                                <ng-icon iconClass="icon-no-transaction" width="120" height="120"></ng-icon>
                            </div>
                            <div class="font-400 font-size-14px line-h-20 color-base-500 text-align-center mt-10">
                                {{"Youhaventmadeany" | translate }}
                            </div>
                        </grid-col>
                    </grid-row>
                </div>
            </div>
        </div>


        <!-- stop-Card-State  -->
        <!-- <grid-row class="justify-content-center align-item-center h-100" *ngIf="!this.showTransaction">
            <grid-col col="5">
                <div class="text-align-center">
                    <ng-icon iconClass="icon-suspend" width="72" height="72"></ng-icon>
                </div>
                <div class="font-400 font-size-14px line-h-20 color-base-500 text-align-center mt-30">
                    {{"YourCardIsStopped" | translate }}
                </div>
                <grid-row class="justify-content-center mt-30">
                    <grid-col col="10">
                        <button class="btn-dft-border br-40" [routerLink]="['/BranchLocator']">
                            {{ "LocateBranch" | translate }}
                        </button>
                    </grid-col>
                </grid-row>
            </grid-col>
        </grid-row> -->

    </div>
    <!-- Empty State non islamic-->
    <ng-container *ngIf="this.serviceType === 'Conventional'">
        <div class="post-login-2-col-3" *ngIf="this.cardDetail?.length ==  0">
            <div class="font-600 font-size-20px line-h-22">
                {{"MyCards" | translate }}
            </div>
            <grid-row class="justify-content-center align-item-center h-100-50">
                <grid-col col="12">
                    <div class="text-align-center">
                        <ng-icon iconClass="icon-creditcard-not-available" width="150" height="125"></ng-icon>
                    </div>
                    <div class="font-400 font-size-20px line-h-25 color-base-700 text-align-center mt-30">
                        {{"NoCreditCardAvailable" | translate }}
                    </div>
                    <div class="font-400 font-size-14px line-h-20 color-base-500 text-align-center mt-5">
                        {{"YouDontHaveCreditCardAccounts" | translate }}
                    </div>
                </grid-col>
            </grid-row>
        </div>
    </ng-container>
    <!-- Empty State non islamic end -->

    <!-- Empty State islamic start -->
    <ng-container *ngIf="this.serviceType === 'Islamic'">
        <div class="post-login-2-col-3" *ngIf="this.cardDetail?.length ==  0">
            <grid-row class="justify-content-center align-item-center h-100vh-80">
                <grid-col col="4" ipad="12">
                    <div class="text-align-center">
                        <ng-icon iconClass="icon-creditcard-not-available" width="307" height="230"></ng-icon>
                    </div>
                    <div class="font-400 font-size-20px line-h-25 color-base-700 text-align-center">
                        {{"Creditcardarenotavailable" | translate }}
                    </div>
                    <div class="font-400 font-size-14px line-h-20 color-base-700 text-align-center mt-10">
                        {{"Cardservicesare" | translate }}
                    </div>

                    <div class="font-400 font-size-14px line-h-20 color-base-500 text-align-center mt-30">
                        {{"Wouldyouliketoswitch" | translate }}
                    </div>
                    <grid-row class="justify-content-center mt-30">
                        <grid-col col="12">
                            <button class="btn-dft" (click)="userSwitch()">
                                {{ "switchtoSahelservices" | translate }}
                            </button>
                        </grid-col>
                    </grid-row>
                </grid-col>
            </grid-row>
        </div>

    </ng-container>
    <!-- Empty State islamic -->
</div>

<!-- Modal Freeze Card-->
<modal modalID="1" [events]="modalObservable.asObservable()" [backdropDismiss]="false" modalDoneButtonText="CONFIRM"
    [whiteButtonStatus]="true" whiteButtonText="CANCEL" (doneButton)="UpdateCardStatus('FREEZ')">
    <div class="text-align-center">
        <ng-icon iconClass="icon-freeze-black" width="75" height="75"></ng-icon>
        <div class="mt-40 font-400 font-size-20px line-h-25 color-base-1300">
            {{ "FreezeThisCard" | translate }}
        </div>
        <div class="font-400 font-size-14px line-h-20 color-base-500 p-10">
            {{ "FreezingThisCardTransaction" | translate }}
        </div>
    </div>
</modal>

<!-- Un-Freeze Card Modal  -->
<modal modalID="2" [events]="modalObservable.asObservable()" [backdropDismiss]="false" modalDoneButtonText="CONFIRM"
    [whiteButtonStatus]="true" whiteButtonText="CANCEL" (doneButton)="UpdateCardStatus('UNFREEZ')">
    <div class="text-align-center">
        <ng-icon iconClass="icon-freeze-black" width="75" height="75"></ng-icon>
        <div class="mt-40 font-400 font-size-20px line-h-25 color-base-1300">
            {{ "UnFreezeThisCard" | translate }}
        </div>
        <div class="font-400 font-size-14px line-h-20 color-base-500 p-10">
            {{ "UnFreezingThisCardTransaction" | translate }}
        </div>
    </div>
</modal>

<!-- Re-issue Card pin Modal-->
<modal modalID="3" [events]="modalObservable.asObservable()" [backdropDismiss]="false" modalDoneButtonText="CONFIRM"
    [whiteButtonStatus]="true" whiteButtonText="CANCEL" (doneButton)="ReIssueCardPinOTp()">
    <!-- UpdateCardStatus('CCRP') -->
    <div class="text-align-center">
        <ng-icon iconClass="icon-re-issue-pin" width="72" height="72"></ng-icon>
        <div class="mt-40 mb-15 font-400 font-size-20px line-h-25 color-base-1300">
            {{ "ReissuePin" | translate }}?
        </div>
        <span class="font-400 font-size-14px line-h-20 color-base-500">
            {{ "YouWilBeChargedWith" | translate }}
        </span>
        <span class="font-600 font-size-14px line-h-20 color-base-1300">
            <span>
                {{"BHD" | translate }}
            </span>
            <span>
                10.000
            </span>
        </span>
        <span class="font-400 font-size-14px line-h-20 color-base-500">
            {{ "AmountWillBeReflected" | translate }}
        </span>
    </div>
</modal>

<!-- Success Card pin Modal -->
<modal modalID="4" [events]="modalObservable.asObservable()" [backdropDismiss]="false" modalDoneButtonText="ChangeNow"
    [whiteButtonStatus]="true" whiteButtonText="MAYBE LATER">
    <div class="text-align-center">
        <ng-icon iconClass="icon-success-black" width="72" height="72"></ng-icon>
        <div class="mt-40 font-400 font-size-20px line-h-25 color-base-1300">
            {{ "TemporaryPinHasbeenSent" | translate }}
        </div>
    </div>
</modal>


<!-- Month statement Modal -->
<modal modalID="5" modalClass="min-height-300" [events]="modalObservable.asObservable()" [backdropDismiss]="false"
    modalDoneButtonText="CONFIRM" (doneButton)="transactionHistory()" [modalDoneButtonDisabled]="this.MonthYear==''"
    [whiteButtonStatus]="true" whiteButtonText="CANCEL">
    <div class="mt-40 font-400 font-size-20px line-h-25 color-base-1300">
        {{ "PleaseViewStatement" | translate }}
    </div>
    <div class="form-group mt-30">
        <label>{{"PleaseViewStatement" | translate}}</label>
        <drop-down-list dropDownImage="false" dropDownSearch="false" [selectedValue]="this.selectedMonth"
            [dropDownData]="this.Monthlist" (itemselected)="onMonthChange($event)">
            {{this.selectedMonth}}
        </drop-down-list>
    </div>
</modal>

<!-- View Card statement Modal -->
<modal modalID="6" modalClass="max-height-350" [events]="modalObservable.asObservable()" [backdropDismiss]="false"
    modalDoneButtonText="Download" (doneButton)="DownloadStatement('')" [whiteButtonStatus]="true"
    whiteButtonText="SendToEmail">
    <div *ngFor="let items of ViewStatementList">
        <div class="font-600 font-size-20px line-h-40 color-base-1300">
            {{ items?.label }}
        </div>
        <div *ngFor="let item of items?.cardTransactions">
            <grid-row class="justify-content-between mt-8">
                <grid-col col="auto">
                    <div class="font-400 font-size-12px line-h-20 color-base-1500">
                        {{item?.transactionDescription}}
                    </div>
                    <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-left"
                        *ngIf=" tem?.transactionDate">
                        {{item?.transactionDate}}
                    </div>
                </grid-col>
                <grid-col col="auto">
                    <div class="font-600 font-size-14px line-h-20 color-error" *ngIf="item?.debitCreditIndicator=='D'">
                        - {{item?.transactionCurrency}} {{item?.transactionAmount}}
                    </div>
                    <div class="font-600 font-size-14px line-h-20 color-success"
                        *ngIf="item?.debitCreditIndicator=='C'">
                        {{item?.transactionCurrency}} {{item?.transactionAmount}}
                    </div>
                    <!-- <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-right">
                        GBP 140.71
                    </div> -->
                </grid-col>
            </grid-row>
        </div>
    </div>
</modal>

<!-- Transaction DETAILS Modal -->
<modal modalID="71" [events]="modalObservable.asObservable()" [backdropDismiss]="false"
    modalDoneButtonText="Share Receipt" (doneButton)="DownloadStatement(SelectedtransactionDetail?.transactionDate)">
    <div class="text-align-center">
        <div class="font-400 font-size-14px line-h-20 color-base-1800">
            <!-- {{"OlympiaSports" | translate}} -->
            {{SelectedtransactionDetail?.transactionDescription}}
        </div>
        <div class="font-500 font-size-24px line-h-32 color-success"
            *ngIf="SelectedtransactionDetail?.debitCreditIndicator=='C'">
            BHD {{SelectedtransactionDetail?.billingAmount}}
        </div>
        <div class="font-500 font-size-24px line-h-32 color-error"
            *ngIf="SelectedtransactionDetail?.debitCreditIndicator=='D'">
            - BHD {{SelectedtransactionDetail?.billingAmount}}
        </div>
    </div>
    <div class="font-400 font-size-14px line-h-20 color-base-1800 mt-24 letter-spacing-1">
        {{"TransactionDetails" | translate}}
    </div>
    <grid-row class="justify-content-between mt-24">
        <!-- <grid-col col="auto">
        <div class="font-400 font-size-12px line-h-20 color-base-1800">
            {{"Balance" | translate}}
        </div>
    </grid-col>
    <grid-col col="auto">
        <div class="font-500 font-size-14px line-h-20 color-base-1300">
            BHD 1,240.54
        </div>
    </grid-col> -->
    </grid-row>
    <grid-row class="justify-content-between mt-24">
        <grid-col col="auto">
            <div class="font-400 font-size-12px line-h-20 color-base-1800">
                {{"RefiD" | translate}}
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-500 font-size-14px line-h-20 color-base-1300">
                {{SelectedtransactionDetail?.referenceNumber}}
            </div>
        </grid-col>
    </grid-row>
    <!-- <grid-row class="justify-content-between mt-24">
        <grid-col col="auto">
            <div class="font-400 font-size-12px line-h-20 color-base-1800">
                {{"Date" | translate}}
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-500 font-size-14px line-h-20 color-base-1300"
                *ngIf="SelectedtransactionDetail?.transactionDate">
                {{SelectedtransactionDetail?.transactionDate}}
            </div>
        </grid-col>
    </grid-row>
    <grid-row class="justify-content-between mt-24">
        <grid-col col="auto">
            <div class="font-400 font-size-12px line-h-20 color-base-1800">
                {{"Time" | translate}}
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-500 font-size-14px line-h-20 color-base-1300">
                {{SelectedtransactionDetail?.transactionDate}}
            </div>
        </grid-col>
    </grid-row> -->

    <grid-row class="justify-content-between mt-24">
        <grid-col col="auto">
            <div class="font-400 font-size-12px line-h-20 color-base-1800">
                {{"Date" | translate}}
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-500 font-size-14px line-h-20 color-base-1300"
                *ngIf="SelectedtransactionDetail?.transactionDate">
                {{ getDate(SelectedtransactionDetail?.transactionDate) }}
            </div>
        </grid-col>
    </grid-row>
    <grid-row class="justify-content-between mt-24">
        <grid-col col="auto">
            <div class="font-400 font-size-12px line-h-20 color-base-1800">
                {{"Time" | translate}}
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-500 font-size-14px line-h-20 color-base-1300">
                {{ getTime(SelectedtransactionDetail?.transactionDate) }}
            </div>
        </grid-col>
    </grid-row>
</modal>

<!-- More actions -->
<modal modalID="10" [events]="modalObservable.asObservable()" [backdropDismiss]="false" modalDoneButtonStatus="false"
    [whiteButtonStatus]="true" [showClose]="false" modalHeading="MoreActions" whiteButtonStatus="true"
    whiteButtonText="CANCEL">
    <!-- <div class="font-400 font-size-14px line-h-20 color-base-1200 letter-spacing-1">
        {{"MoreActions" | translate}}
    </div> -->
    <div class="link border-bottom border-color-2100 pb-24 pt-24" (click)="showSuccessModal(19)"
        *ngIf="this.cardProductCode !== '007' && this.cardProductCode !== '050'">
        <!-- *ngIf="this.cardService.pendingCPR == '' && this.cardService.pendingStatus == ''" -->

        <!-- <ng-icon iconClass="icon-manage-pin v-align-middle" width="26" height="26"></ng-icon> -->
        <ng-icon iconClass="icon-manage-card-green v-align-middle" width="26" height="26"></ng-icon>
        <span class="font-400 font-size-14px color-base-1300 ml-16">
            {{ "ManageCardLimit" | translate }}
        </span>
    </div>

    <!-- <div class="link border-bottom border-color-2100 pb-24 pt-24">
        <ng-icon iconClass="icon-manage-pin-green v-align-middle" width="26" height="26"></ng-icon>
        <span class="font-400 font-size-14px color-base-1300 ml-16">
            {{ "ManageCardPIN" | translate }}
        </span>
    </div> -->
    <div class="link border-bottom border-color-2100 pb-24 pt-24"
        (click)="RequestPhysicalSendOTP('RequestPhysicalCard')"
        *ngIf="this.selectedCardDetail?.physicalOrVirtual != 'Physical'">
        <ng-icon iconClass="icon-physical-card v-align-middle" width="26" height="26"></ng-icon>
        <span class="font-400 font-size-14px color-base-1300 ml-16">
            {{ "RequestPhysicalCard" | translate }}
        </span>
    </div>
    <div class="link border-bottom border-color-2100 pb-24 pt-24" (click)="showSuccessModal(12)"
        *ngIf="this.selectedCardDetail?.physicalOrVirtual == 'Physical'">
        <!-- <ng-icon iconClass="icon-replace-card v-align-middle" width="26" height="26"></ng-icon> -->
        <ng-icon iconClass="icon-replace-card-green v-align-middle" width="26" height="26"></ng-icon>
        <span class="font-400 font-size-14px color-base-1300 ml-16">
            {{ "ReplaceCard" | translate }}
        </span>
    </div>

    <!-- <div class="link border-bottom border-color-2100 pb-24 pt-24"
        *ngIf="this.cardService.pendingCPR != '' && this.cardService.pendingStatus != ''">
        <ng-icon iconClass="icon-manage-pin v-align-middle" width="26" height="26"></ng-icon>
        <span class="font-400 font-size-14px color-base-1300 ml-16">
            {{ "ManageCardLimit" | translate }}
        </span>
    </div> -->
    <div class="link border-bottom border-color-2100 pb-24 pt-24" (click)="cardRequestLetters()">
        <!-- <ng-icon iconClass="icon-email-blue-sm v-align-middle" width="26" height="26"></ng-icon> -->
        <ng-icon iconClass="icon-service-latter-green v-align-middle" width="26" height="26"></ng-icon>
        <span class="font-400 font-size-14px color-base-1300 ml-16">
            {{ "ServiceRequestLetters" | translate }}
        </span>
    </div>
    <!-- <div class="link border-bottom border-color-2100 pb-24 pt-24" (click)="showModal(18,'close')" *ngIf="this.selectedCardDetail?.physicalOrVirtual != 'Physical'"> -->
    <div class="link border-bottom border-color-2100 pb-24 pt-24" (click)="ReplaceDigitalSendOTP()"
        *ngIf="this.selectedCardDetail?.physicalOrVirtual != 'Physical'">
        <!-- <ng-icon iconClass="icon-replace-card v-align-middle" width="26" height="26"></ng-icon> -->
        <ng-icon iconClass="icon-replace-card-green v-align-middle" width="26" height="26"></ng-icon>
        <span class="font-400 font-size-14px color-base-1300 ml-16">
            {{ "ReplaceCardDigi" | translate }}
        </span>
    </div>

    <!-- <div class="link border-bottom border-color-2100 pb-24 pt-24" (click)="showSuccessModal(11)">
        <ng-icon iconClass="icon-email-blue-sm v-align-middle" width="26" height="26"></ng-icon>
        <ng-icon iconClass="icon-service-latter-green v-align-middle" width="26" height="26"></ng-icon>
        <span class="font-400 font-size-14px color-base-1300 ml-16">
            {{ "ServiceRequestLetters" | translate }}
        </span>
    </div> -->
    <div class="link border-bottom border-color-2100 pb-24 pt-24" (click)="sinadUserpin()">
        <!-- <ng-icon iconClass="icon-email-blue-sm v-align-middle" width="26" height="26"></ng-icon> -->
        <ng-icon iconClass="icon-manage-pin-green" width="26" height="26"></ng-icon>
        <span class="font-400 font-size-14px color-base-1300 ml-16">
            {{ "ManageCardPIN" | translate }}
        </span>
    </div>

    <!-- <div class="link border-bottom border-color-2100 pb-24 pt-24" (click)="showSuccessModal(14)" *ngIf="this.selectedCardDetail?.physicalOrVirtual != 'Physical'"> -->
</modal>

<!-- Request Letter -->
<modal modalID="11" [events]="modalObservable.asObservable()" [backdropDismiss]="false" [hideFooter]="true"
    modalDoneButtonStatus="false">
    <div class="font-400 font-size-14px line-h-20 color-base-1200 letter-spacing-1">
        {{"RequestLetter" | translate}}
    </div>
    <div class="link border-bottom border-color-2100 pb-24 pt-24 font-400 font-size-14px color-base-1300"
        *ngFor="let item of this.LettersList" (click)="requestLetterSelectedItem('',item)">
        {{item.desc_eng}}
    </div>
</modal>

<!-- Request Letter -->
<modal modalID="12" [events]="modalObservable.asObservable()" [backdropDismiss]="false" [hideFooter]="true"
    modalDoneButtonStatus="false" modalHeading="ReasonReplace">
    <!-- <div class="font-400 font-size-14px line-h-20 color-base-1200 letter-spacing-1">
        {{"ReasonReplace" | translate}}
    </div> -->
    <div *ngFor="let item of this.ReasonsList">
        <div class="link border-bottom border-color-2100 pb-24 pt-24 font-400 font-size-14px color-base-1300"
            (click)="cardReplacementReason(13,item)">
            {{item?.labelEn}}
        </div>

    </div>


    <!-- <div class="link border-bottom border-color-2100 pb-24 pt-24 font-400 font-size-14px color-base-1300"
        (click)="showSuccessModal(13)">
        {{ "MyCardDamaged" | translate }}
    </div>
    <div class="link border-bottom border-color-2100 pb-24 pt-24 font-400 font-size-14px color-base-1300"  (click)="showSuccessModal(13)">
        {{ "MyCardExpired" | translate }}
    </div>
    <div class="link pb-24 pt-24 font-400 font-size-14px color-base-1300"  (click)="showSuccessModal(13)">
        {{ "MyCardLost" | translate }}
    </div> -->
</modal>

<!-- Replacing Change Card -->
<modal modalID="13" [events]="modalObservable.asObservable()" [backdropDismiss]="false" modalDoneButtonText="CONTINUE"
    [whiteButtonStatus]="true" whiteButtonText="CANCEL" (doneButton)="SendOtp()">
    <!-- (doneButton)="CardReplacementRequest()" -->
    <div class="text-align-center">
        <ng-icon iconClass="icon-change-card" width="77" height="72"></ng-icon>
        <div class="font-size-16px color-base-1300 font-600 line-h-25 mt-30 letter-spacing-03">
            {{"SetNewLimit" | translate}}
        </div>
        <div class="font-size-14px color-base-400 font-400 line-h-25 mt-10 letter-spacing-03">
            {{"ReplacingChargeYou" | translate}}
        </div>
        <div class="letter-spacing-03 color-base-1300">
            <strong>{{"BHD" | translate }} 500.000</strong>
            <span class="color-base-400 font-size-14px line-h-25">
                {{"OnCreditContinue" | translate}}
            </span>
        </div>
        <div class="color-base-400  font-size-14px line-h-25 mt-10">
            <span>
                {{ "YouContinueCard" | translate}}
            </span>
            <strong class="color-base-1300">
                {{"The" | translate }} {{"BHD" | translate }} 5.50 ({{"BHD" | translate }} 5 , {{"VAT" | translate }}
                {{"BHD" | translate }} 0.5)
            </strong>
            <span>
                {{ "ChargedCardApplied" | translate}}
            </span>
        </div>
    </div>
</modal>

<!-- Mobile OTP Modal -->
<modal modalID="14" [events]="modalObservable.asObservable()" [backdropDismiss]="false" modalDoneButtonText="Verify"
    [modalDoneButtonDisabled]="isValidOtp()" (doneButton)="VerifyMobileOtp()">
    <grid-row class="justify-content-center">
        <grid-col col="6">
            <div class="text-align-center">
                <ng-icon iconClass="icon-otp-pin br-8 bg-nuetral-primary" width="80" height="80"></ng-icon>
                <div class="mt-30">
                    <span class="color-base-700 font-size-20px font-400 line-h-25">
                        {{ "Enter4digit" | translate }}
                    </span>
                    <span class="color-primary font-size-20px font-400 line-h-25"
                        *ngIf="this.auth?.RegisteredUser?.mobile">
                        {{"+973"+this.commonP.maskMobileNumber(this.auth?.RegisteredUser?.mobile)}} {{ "Or" | translate
                        }}
                    </span>
                    <span class="color-primary font-size-20px font-400 line-h-25"
                        *ngIf="!this.auth?.RegisteredUser?.mobile">
                        {{"+973"+this.commonP.maskMobileNumber(this.MobNum)}} {{ "Or" | translate }}
                    </span>
                    <span class="color-primary font-size-20px font-400 line-h-25"
                        *ngIf="this.auth?.RegisteredUser?.email">
                        {{this.commonP.maskEmail(this.auth?.RegisteredUser?.email)}}

                    </span>
                    <span class="color-primary font-size-20px font-400 line-h-25"
                        *ngIf="!this.auth?.RegisteredUser?.email">
                        {{this.commonP.maskEmail(this.Eemail)}}

                    </span>
                </div>
            </div>
        </grid-col>
    </grid-row>
    <div class="mt-50 form-group">
        <ng-otp-input (onInputChange)="onOtpChange($event)" (keydown)="onKeyDown($event)" allowNumbersOnly='true'
            [config]="{length:6,allowNumbersOnly:true,isPasswordInput:true}"></ng-otp-input>
        <!-- <input type="text" mask="9999" placeholder="Pin"  [(ngModel)]="otp"> -->
    </div>
    <grid-row class="justify-content-between align-item-center mt-50">
        <!-- <grid-col col="auto">
            <div class="border box-shadow br-40 pt-10 pb-10 pl-15 pr-15">
                <div class="font-600 font-size-12px color-primary letter-spacing-1">
                  {{ "Resend" | translate }}
                  <span *ngIf="true" class="font-600 font-size-12px color-primary letter-spacing-1">{{timerexpire}}</span>
                </div>
              </div>
        </grid-col> -->


        <grid-col col="auto" *ngIf="!OptTimerbtnShow">
            <div class="border box-shadow br-40 pt-10 pb-10 pl-15 pr-15 link" (click)="ResendOtp()">
                <div class="font-600 font-size-12px color-primary letter-spacing-1">
                    {{ "Resend" | translate }}
                </div>
            </div>
        </grid-col>
        <grid-col col="auto" *ngIf="OptTimerbtnShow">
            <div class="border box-shadow br-40 pt-10 pb-10 pl-15 pr-15">
                <div class="font-600 font-size-12px color-primary letter-spacing-1">
                    {{ "Resend" | translate }}
                    <span *ngIf="true"
                        class="font-600 font-size-12px color-primary letter-spacing-1">{{timerexpire}}</span>
                </div>
            </div>
        </grid-col>
        <!-- 
        <grid-col col="auto">
            <div class="link font-600 font-size-12px color-primary">
                {{ "ChangeMobileNumber" | translate }}
            </div>
        </grid-col> -->
    </grid-row>
</modal>

<!-- Request Letter -->
<modal modalID="15" [events]="modalObservable.asObservable()" [backdropDismiss]="false" [hideFooter]="true"
    modalDoneButtonStatus="false">
    <div class="font-400 font-size-14px line-h-20 color-base-1200 letter-spacing-1">
        {{"RequestLetter" | translate}}
    </div>
    <div class="link border-bottom border-color-2100 pb-24 pt-24 font-400 font-size-14px color-base-1300"
        (click)="showSuccessModal(16)">
        {{ "LoanLetter" | translate }}
    </div>
    <div class="link border-bottom border-color-2100 pb-24 pt-24 font-400 font-size-14px color-base-1300"
        (click)="showSuccessModal(16)">
        {{ "OutstandingBalanceLetter" | translate }}
    </div>
    <div class="link border-bottom border-color-2100 pb-24 pt-24 font-400 font-size-14px color-base-1300"
        (click)="showSuccessModal(16)">
        {{ "StatementAccount" | translate }}
    </div>
    <div class="link border-bottom border-color-2100 pb-24 pt-24 font-400 font-size-14px color-base-1300"
        (click)="showSuccessModal(16)">
        {{ "SemiAnnualStatement" | translate }}
    </div>
    <div class="link pb-24 pt-24 font-400 font-size-14px color-base-1300" (click)="cardReplacementSuccess()">
        {{ "ClearanceLetter" | translate }}
    </div>
</modal>

<!-- Change Card -->
<modal modalID="16" [events]="modalObservable.asObservable()" [backdropDismiss]="false" modalDoneButtonText="CONTINUE"
    [whiteButtonStatus]="true" whiteButtonText="CANCEL" (doneButton)="CheckStatus()">
    <div class="text-align-center">
        <ng-icon iconClass="icon-email-black-big" width="77" height="72"></ng-icon>
        <div class="font-size-20px color-base-1300 font-400 line-h-25 mt-30 letter-spacing-03">
            {{"PaymentContinue" | translate}}
        </div>
        <div class="color-base-400  font-size-14px line-h-25 mt-10">
            <span>
                {{ "PaymentsOf" | translate}}
            </span>
            <strong class="color-base-1300">
                {{ "BHD" | translate}} {{this.TotalAmount}} ({{ "BHD" | translate}} {{this.PaymentDetail?.charges}} , {{
                "VAT" | translate}} {{ "BHD" | translate}} {{this.PaymentDetail?.vat}})
            </strong>
            <span>
                {{ "AreRequiredLetter" | translate}}
            </span>
        </div>
    </div>
</modal>

<!-- manage Pin -->
<modal modalID="17" [events]="modalObservable.asObservable()" [backdropDismiss]="false" [modalDoneButtonStatus]="false"
    [whiteButtonStatus]="true" [showClose]="false" modalHeading="ManagePIN" whiteButtonText="CANCEL">

    <!-- <div class="font-size-14px color-base-1200 font-400 text-uppercase line-h-25 letter-spacing-03">
        {{"ManagePIN" | translate}}
    </div> -->

    <div class="pt-24 pb-24 link" (click)="ChangeCardPinImtiaz()">
        <!-- routerLink]="['/ChangePinVerify']" -->
        <div class="font-size-14px color-base-1300 font-400 line-h-20" (click)="ChangeCardPinImtiaz()">
            {{"ChangeCardPIN" | translate}}
        </div>

        <div class="font-size-14px color-base-500 font-400 mt-5 line-h-18">
            {{"ChangeyourcardPIN" | translate}}
        </div>
    </div>

    <div class="pt-24 pb-24 border-top border-color-2100 link" (click)="showSuccessModal(3)">
        <div class="font-size-14px color-base-1300 font-400 line-h-20">
            {{"ReissuePin" | translate}}
        </div>

        <div class="font-size-14px color-base-500 font-400 mt-5 line-h-18">
            {{"RequestanewPIN" | translate}}
        </div>
    </div>

</modal>

<!-- Email OTP Modal -->
<modal modalID="18" [events]="modalObservable.asObservable()" [backdropDismiss]="false" modalDoneButtonText="Verify"
    [modalDoneButtonDisabled]="isValidOtp()" (doneButton)="CardReplacementRequest()">
    <grid-row class="justify-content-center">
        <grid-col col="6">
            <div class="text-align-center">
                <ng-icon iconClass="icon-otp-pin br-8 bg-nuetral-primary" width="80" height="80"></ng-icon>
                <div class="mt-30">
                    <span class="color-base-700 font-size-20px font-400 line-h-25">
                        {{ "Enter4digit" | translate }}
                    </span>
                    <span class="color-primary font-size-20px font-400 line-h-25"
                        *ngIf="this.auth?.RegisteredUser?.email">
                        {{this.commonP.maskEmail(this.auth?.RegisteredUser?.email)}}

                    </span>
                    <span class="color-primary font-size-20px font-400 line-h-25"
                        *ngIf="!this.auth?.RegisteredUser?.email">
                        {{this.commonP.maskEmail(this.Eemail)}}

                    </span>
                </div>
            </div>
        </grid-col>
    </grid-row>
    <div class="mt-50 form-group">
        <ng-otp-input (onInputChange)="onOtpChange($event)" (keydown)="onKeyDown($event)" allowNumbersOnly='true'
            [config]="{length:4,allowNumbersOnly:true}"></ng-otp-input>
        <!-- <input type="text" mask="9999" placeholder="Pin"  [(ngModel)]="otp"> -->
    </div>
    <grid-row class="justify-content-between align-item-center mt-50">
        <!-- <grid-col col="auto">
            <div class="border box-shadow br-40 pt-10 pb-10 pl-15 pr-15">
                <div class="font-600 font-size-12px color-primary letter-spacing-1">
                  {{ "Resend" | translate }}
                  <span *ngIf="true" class="font-600 font-size-12px color-primary letter-spacing-1">{{timerexpire}}</span>
                </div>
              </div>
        </grid-col> -->


        <grid-col col="auto" *ngIf="!OptTimerbtnShow">
            <div class="border box-shadow br-40 pt-10 pb-10 pl-15 pr-15 link" (click)="SendOtp()"
                *ngIf="this.selectedCardDetail?.physicalOrVirtual == 'Physical'">
                <div class="font-600 font-size-12px color-primary letter-spacing-1">
                    {{ "Resend" | translate }}
                </div>
            </div>
            <div class="border box-shadow br-40 pt-10 pb-10 pl-15 pr-15 link" (click)="RDCEmailOTP()"
                *ngIf="this.selectedCardDetail?.physicalOrVirtual != 'Physical' && this.Action != 'RequestPhysicalCard'">
                <div class="font-600 font-size-12px color-primary letter-spacing-1">
                    {{ "Resend" | translate }}
                </div>
            </div>
            <div class="border box-shadow br-40 pt-10 pb-10 pl-15 pr-15 link" (click)="RequestPhysicalEmailOTP()"
                *ngIf="this.selectedCardDetail?.physicalOrVirtual != 'Physical' && this.Action == 'RequestPhysicalCard' ">
                <div class="font-600 font-size-12px color-primary letter-spacing-1">
                    {{ "Resend" | translate }}
                </div>
            </div>
        </grid-col>
        <grid-col col="auto" *ngIf="OptTimerbtnShow">
            <div class="border box-shadow br-40 pt-10 pb-10 pl-15 pr-15">
                <div class="font-600 font-size-12px color-primary letter-spacing-1">
                    {{ "Resend" | translate }}
                    <span *ngIf="true"
                        class="font-600 font-size-12px color-primary letter-spacing-1">{{timerexpire}}</span>
                </div>
            </div>
        </grid-col>

        <!-- <grid-col col="auto">
            <div class="link font-600 font-size-12px color-primary">
                {{ "ChangeMobileNumber" | translate }} 
            </div>
        </grid-col> -->
    </grid-row>
</modal>


<!-- Manage card limit -->
<modal modalID="19" [events]="modalObservable.asObservable()" [backdropDismiss]="false" [modalDoneButtonStatus]="false"
    [whiteButtonStatus]="true" [hideFooter]="false" [hideHeader]="false" whiteButtonText="CANCEL">

    <div class="font-size-14px color-base-1200 font-400 text-uppercase line-h-25 letter-spacing-03">
        {{"ManageCardLimit" | translate}}
    </div>
    <!-- <div class="pt-24 pb-24 link" > -->
    <!-- (click)="cardLimitPermanent()" -->
    <!-- <div class="font-size-14px color-base-1300 font-400 line-h-20">
            {{"IncreasePermanently" | translate}}
        </div>
        <div class="font-size-14px color-base-500 font-400 mt-5 line-h-18">
            {{"SetPermanentAdditional" | translate}}
        </div> -->
    <!-- </div> -->

    <!-- <div class="pt-24 pb-24 link" (click)="cardLimitPermanent()">
        <div class="font-size-14px color-base-1300 font-400 line-h-20">
            {{"IncreasePermanently" | translate}}
        </div>
        <div class="font-size-14px color-base-500 font-400 mt-5 line-h-18">
            {{"SetANewPermanentLimit" | translate}}
        </div>
    </div> -->
    <div class="pt-24 pb-24 border-bottom border-color-2100 link" (click)="cardLimitTemporary()">
        <div class="font-size-14px color-base-1300 font-400 line-h-20">
            {{"IncreaseLimitTemporarily" | translate}}
        </div>
        <div class="font-size-14px color-base-500 font-400 mt-5 line-h-18">
            {{"YourCardlimitWillIncreased" | translate}}
        </div>
    </div>
    <!-- <div class="pt-24 pb-24 border-top border-color-2100 link" (click)="cardLimitPermanent()">
        <div class="font-size-14px color-base-1300 font-400 line-h-20">
            {{"DecreaseLimit" | translate}}
        </div>
        <div class="font-size-14px color-base-500 font-400 mt-5 line-h-18">
            {{"DecreaseCardLimit" | translate}}
        </div>
    </div> -->
</modal>

<!-- Enter your 4-digit PIN -->
<modal modalID="20" [events]="modalObservable.asObservable()" [backdropDismiss]="false" [modalDoneButtonStatus]="false">
    <grid-row class="justify-content-center">
        <grid-col col="12">
            <div class="text-align-center">
                <div class="font-400 font-size-20px line-h-28 color-base-700 letter-spacing-1">
                    {{ "Enteryour4digitPIN" | translate }}
                </div>
                <div class="font-400 font-size-14px line-h-22 color-base-500 letter-spacing-1 mt-10">
                    {{ "PleaseAuthenticate4DigitPIN" | translate }}
                </div>
            </div>
        </grid-col>
    </grid-row>
    <div class="mt-50 form-group">
        <ng-otp-input (onInputChange)="onOtpChange($event)" (keydown)="onKeyDown($event)" allowNumbersOnly='true'
            [config]="{length:4,allowNumbersOnly:true}"></ng-otp-input>
    </div>
</modal>

<!-- Account verify Popup -->
<modal modalID="21" [events]="modalObservable.asObservable()" [backdropDismiss]="false" modalDoneButtonText="VERIFY"
    [whiteButtonStatus]="true" whiteButtonText="CANCEL" (doneButton)="CheckStatus()">
    <div class="text-align-center">
        <ng-icon iconClass="icon-verify-account" width="72" height="72"></ng-icon>
        <div class="font-size-20px color-base-1300 font-400 line-h-25 mt-30 letter-spacing-03">
            {{"AccountVerification" | translate}}
        </div>
        <div class="color-base-400  font-size-14px line-h-25 mt-10">
            {{"SeemsAccountVerified" | translate}}
        </div>
    </div>
</modal>


<modal modalID="22" [events]="modalObservable.asObservable()" [backdropDismiss]="false" modalDoneButtonText="Verify"
    [modalDoneButtonDisabled]="isValidOtp()" (doneButton)="VerifyEmailOTPRegister()">
    <grid-row class="justify-content-center">
        <grid-col col="6">
            <div class="text-align-center">
                <ng-icon iconClass="icon-otp-pin br-8 bg-nuetral-primary" width="80" height="80"></ng-icon>
                <div class="mt-30">
                    <span class="color-base-700 font-size-20px font-400 line-h-25">
                        {{ "Enter4digit" | translate }}
                    </span>
                    <span class="color-primary font-size-20px font-400 line-h-25"
                        *ngIf="this.auth?.RegisteredUser?.email">
                        {{this.commonP.maskEmail(this.auth?.RegisteredUser?.email)}}

                    </span>
                    <span class="color-primary font-size-20px font-400 line-h-25"
                        *ngIf="!this.auth?.RegisteredUser?.email">
                        {{this.commonP.maskEmail(this.Eemail)}}

                    </span>
                </div>
            </div>
        </grid-col>
    </grid-row>
    <div class="mt-50 form-group">
        <ng-otp-input (onInputChange)="onOtpChange($event)" (keydown)="onKeyDown($event)" allowNumbersOnly='true'
            [config]="{length:4,allowNumbersOnly:true}"></ng-otp-input>
        <!-- <input type="text" mask="9999" placeholder="Pin"  [(ngModel)]="otp"> -->
    </div>
    <grid-row class="justify-content-between align-item-center mt-50">
        <!-- <grid-col col="auto">
            <div class="border box-shadow br-40 pt-10 pb-10 pl-15 pr-15">
                <div class="font-600 font-size-12px color-primary letter-spacing-1">
                  {{ "Resend" | translate }}
                  <span *ngIf="true" class="font-600 font-size-12px color-primary letter-spacing-1">{{timerexpire}}</span>
                </div>
              </div>
        </grid-col> -->


        <grid-col col="auto" *ngIf="!OptTimerbtnShow">
            <div class="border box-shadow br-40 pt-10 pb-10 pl-15 pr-15 link" (click)="SendOtp()"
                *ngIf="this.selectedCardDetail?.physicalOrVirtual == 'Physical'">
                <div class="font-600 font-size-12px color-primary letter-spacing-1">
                    {{ "Resend" | translate }}
                </div>
            </div>
            <div class="border box-shadow br-40 pt-10 pb-10 pl-15 pr-15 link" (click)="RDCEmailOTP()"
                *ngIf="this.selectedCardDetail?.physicalOrVirtual != 'Physical' && this.Action != 'RequestPhysicalCard'">
                <div class="font-600 font-size-12px color-primary letter-spacing-1">
                    {{ "Resend" | translate }}
                </div>
            </div>
            <div class="border box-shadow br-40 pt-10 pb-10 pl-15 pr-15 link" (click)="RequestPhysicalEmailOTP()"
                *ngIf="this.selectedCardDetail?.physicalOrVirtual != 'Physical' && this.Action == 'RequestPhysicalCard' ">
                <div class="font-600 font-size-12px color-primary letter-spacing-1">
                    {{ "Resend" | translate }}
                </div>
            </div>
        </grid-col>
        <grid-col col="auto" *ngIf="OptTimerbtnShow">
            <div class="border box-shadow br-40 pt-10 pb-10 pl-15 pr-15">
                <div class="font-600 font-size-12px color-primary letter-spacing-1">
                    {{ "Resend" | translate }}
                    <span *ngIf="true"
                        class="font-600 font-size-12px color-primary letter-spacing-1">{{timerexpire}}</span>
                </div>
            </div>
        </grid-col>

        <!-- <grid-col col="auto">
            <div class="link font-600 font-size-12px color-primary">
                {{ "ChangeMobileNumber" | translate }} 
            </div>
        </grid-col> -->
    </grid-row>
</modal>

<modal modalID="23" [events]="modalObservable.asObservable()" [backdropDismiss]="false" modalDoneButtonText="Verify"
    [modalDoneButtonDisabled]="isValidOtpemail()" (doneButton)="VerifyEmailOTP()">
    <grid-row class="justify-content-center">
        <grid-col col="6" mobile="12">
            <div class="text-align-center">
                <ng-icon iconClass="icon-otp-pin br-8 bg-nuetral-primary" width="80" height="80"></ng-icon>
                <div class="mt-30">
                    <div class="color-base-700 font-size-20px font-400 line-h-25">
                        {{ "Enter6digit" | translate }}
                    </div>
                    <!-- <span class="color-primary font-size-20px font-400 line-h-25"
                                            *ngIf="this.auth?.RegisteredUser?.email">
                                            {{this.commonP.maskEmail(this.auth?.RegisteredUser?.email)}}
                    
                                        </span> -->
                    <div class="color-primary font-size-16px font-400 line-h-25">
                        {{"+973"+this.mobilNomasked}}
                    </div>
                    <div class="color-primary font-size-16px font-400 line-h-25">
                        {{ "Or" | translate }}
                    </div>
                    <div class="color-primary font-size-16px font-400 line-h-25">
                        {{this.maskedEmail}}
                    </div>

                    <!-- <span class="color-base-700 font-size-20px font-400 line-h-25">
                        {{ "Enter6digit" | translate }}
                    </span>
                  
                    <span class="color-primary font-size-20px font-400 line-h-25">
                        {{"+973"+this.mobilNomasked}} or
                    </span>
                    <span class="color-primary font-size-20px font-400 line-h-25">
                        {{this.maskedEmail}}

                    </span> -->
                </div>
            </div>
        </grid-col>
    </grid-row>

    <div class="mt-50 form-group">
        <!-- <ng-otp-input (onInputChange)="onOtpChangeverify($event)" (keydown)="onKeyDown($event)" allowNumbersOnly='true'
            [config]="{length:4,allowNumbersOnly:true}"></ng-otp-input> -->
        <ng-otp-input #otpInput (onInputChange)="onOtpChangeverify($event)" allowNumbersOnly="true"
            [config]="{length: 6, allowNumbersOnly: true,isPasswordInput:true, inputStyles: {'inputmode': 'numeric'}}">
        </ng-otp-input>
        <!-- <input type="text" mask="9999" placeholder="Pin"  [(ngModel)]="otp"> -->
    </div>
    <grid-row class="justify-content-center mt-50">
        <!-- <grid-col col="auto">
            <div class="border box-shadow br-40 pt-10 pb-10 pl-15 pr-15">
                <div class="font-600 font-size-12px color-primary letter-spacing-1">
                  {{ "Resend" | translate }}
                  <span *ngIf="true" class="font-600 font-size-12px color-primary letter-spacing-1">{{timerexpire}}</span>
                </div>
              </div>
        </grid-col> -->


        <grid-col col="auto" *ngIf="!OptTimerbtnShow">
            <div class="border box-shadow br-40 pt-10 pb-10 pl-15 pr-15 link" (click)="resendEmailOTP()">
                <div class="font-600 font-size-12px color-primary letter-spacing-1">
                    {{ "Resend" | translate }}
                </div>
            </div>
            <!-- <div class="border box-shadow br-40 pt-10 pb-10 pl-15 pr-15 link" (click)="RDCEmailOTP()"
                *ngIf="this.selectedCardDetail?.physicalOrVirtual != 'Physical' && this.Action != 'RequestPhysicalCard'">
                <div class="font-600 font-size-12px color-primary letter-spacing-1">
                    {{ "Resend" | translate }}
                </div>
            </div>
            <div class="border box-shadow br-40 pt-10 pb-10 pl-15 pr-15 link" (click)="RequestPhysicalEmailOTP()"
                *ngIf="this.selectedCardDetail?.physicalOrVirtual != 'Physical' && this.Action == 'RequestPhysicalCard' ">
                <div class="font-600 font-size-12px color-primary letter-spacing-1">
                    {{ "Resend" | translate }}
                </div>
            </div> -->
        </grid-col>
        <grid-col col="auto" *ngIf="OptTimerbtnShow">
            <div class="border box-shadow br-40 pt-10 pb-10 pl-15 pr-15">
                <div class="font-600 font-size-12px color-primary letter-spacing-1">
                    {{ "Resend" | translate }}
                    <span *ngIf="true"
                        class="font-600 font-size-12px color-primary letter-spacing-1">{{timerexpire}}</span>
                </div>
            </div>
        </grid-col>

        <!-- <grid-col col="auto">
            <div class="link font-600 font-size-12px color-primary">
                {{ "ChangeMobileNumber" | translate }} 
            </div>
        </grid-col> -->
    </grid-row>
</modal>

<!-- <modal modalID="24" [events]="modalObservable.asObservable()" [backdropDismiss]="false" modalDoneButtonText="Verify"
    [modalDoneButtonDisabled]="isValidMobileOtp()" (doneButton)="verifyMobile()">
    <grid-row class="justify-content-center">
        <grid-col col="6">
            <div class="text-align-center">
                <ng-icon iconClass="icon-otp-pin br-8 bg-nuetral-primary" width="80" height="80"></ng-icon>
                <div class="mt-30">
                    <span class="color-base-700 font-size-20px font-400 line-h-25">
                        {{ "Enter4digit" | translate }}
                    </span>
                    <span class="color-primary font-size-20px font-400 line-h-25">
                        {{this.maskMobileNO}}
                    </span>
                </div>
            </div>
        </grid-col>
    </grid-row>
    <div class="mt-50 form-group">
        <ng-otp-input  #otpInputMobile (onInputChange)="onMobileOtpChange($event)" (keydown)="onKeyDown($event)" allowNumbersOnly='true'
            [config]="{length:4,allowNumbersOnly:true}"></ng-otp-input>
        <input type="text" mask="9999" placeholder="Pin"  [(ngModel)]="otp">
    </div>
    <grid-row class="justify-content-between align-item-center mt-50">
        <grid-col col="auto">
            <div class="border box-shadow br-40 pt-10 pb-10 pl-15 pr-15">
                <div class="font-600 font-size-12px color-primary letter-spacing-1">
                  {{ "Resend" | translate }}
                  <span *ngIf="true" class="font-600 font-size-12px color-primary letter-spacing-1">{{timerexpire}}</span>
                </div>
              </div>
        </grid-col>


        <grid-col col="auto" *ngIf="!OptTimerbtnShow">
            <div class="border box-shadow br-40 pt-10 pb-10 pl-15 pr-15 link" (click)="ResendOTP()">
                <div class="font-600 font-size-12px color-primary letter-spacing-1">
                    {{ "Resend" | translate }}
                </div>
            </div>
        </grid-col>
        <grid-col col="auto" *ngIf="OptTimerbtnShow">
            <div class="border box-shadow br-40 pt-10 pb-10 pl-15 pr-15">
                <div class="font-600 font-size-12px color-primary letter-spacing-1">
                    {{ "Resend" | translate }}
                    <span *ngIf="true"
                        class="font-600 font-size-12px color-primary letter-spacing-1">{{timerexpire}}</span>
                </div>
            </div>
        </grid-col>
        
        <grid-col col="auto">
            <div class="link font-600 font-size-12px color-primary">
                {{ "ChangeMobileNumber" | translate }}
            </div>
        </grid-col>
    </grid-row>
</modal> -->